<core-icon *ngIf="icon" class="tag-icon" size="xs" [icon]="icon"> </core-icon>
<div class="tag-label">
  <div class="tag-label__text">
    <ng-content></ng-content>
  </div>
  <div class="tag-label__subtext">
    <ng-content select="[coreTagLabelSubtext]"></ng-content>
  </div>
</div>
